import { useTranslation } from "react-i18next";
import { Language } from "utils/constants";

const LanguageToggle = () => {
    const { i18n } = useTranslation();
    const setLanguage = (language: string) => {
        localStorage.setItem("Lang", language)
        i18n.changeLanguage(language)
    };

    const lang = i18n.language.toLowerCase();
    const enClasses = ["button", "is-primary", "is-small"];
    enClasses.push(lang === "en" ? "is-selected" : "is-outlined");
    const frClasses = ["button", "is-primary", "is-small"];
    frClasses.push(lang === "fr" ? "is-selected" : "is-outlined");

    return (
        <div data-testid="language-toggle" className="buttons has-addons">
            <span className={enClasses.join(" ")} onClick={() => setLanguage(Language.ENGLISH)}>
                En
            </span>
            <span className={frClasses.join(" ")} onClick={() => setLanguage(Language.FRENCH)}>
                Fr
            </span>
        </div>
    );
};

export default LanguageToggle;
